import styled from 'styled-components'

export const DialogTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const DialogTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const DialogTitleDivider = styled.span`
  color: #9ca3af;
  font-weight: 400;
  margin: 0 4px;
`
